module.exports = __webpack_public_path__ + "img/clinical-perspective.33cb470a.png";